<template>
  <a-modal
    :visible="visible"
    :width="640"
    title="Filtrar e ordenar"
    wrap-class-name="freight-table-tab-filter-modal"
    @cancel="$emit('close')"
  >
    <div class="freight-table-tab-filter-modal__section">
      <h4 class="freight-table-tab-filter-modal__label">Ordenar por</h4>

      <a-radio-group v-model="draft.sort">
        <a-radio value="az">A-Z</a-radio>
        <a-radio value="za">Z-A</a-radio>
      </a-radio-group>
    </div>

    <div class="freight-table-tab-filter-modal__section">
      <h4 class="freight-table-tab-filter-modal__label">Status</h4>

      <a-radio-group
        v-model="draft.status"
        class="freight-table-tab-filter-modal__stacked"
      >
        <a-radio :value="FREIGHT_TABLE_STATUS.ATIVA">Ativo</a-radio>
        <a-radio :value="FREIGHT_TABLE_STATUS.INATIVA">Inativo</a-radio>
      </a-radio-group>
    </div>

    <template slot="footer">
      <a-button @click="handleClear">Limpar filtro</a-button>
      <a-button type="primary" :disabled="!isDirty" @click="handleApply">
        Aplicar
      </a-button>
    </template>
  </a-modal>
</template>

<script>
import { FREIGHT_TABLE_STATUS } from "../../constants/freightTableStatus";

function buildDraft(filters) {
  const source = filters || {};

  return {
    sort: source.sort || null,
    status: source.status || null,
  };
}

export default {
  name: "FreightTableTabFilterModal",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    filters: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      FREIGHT_TABLE_STATUS,
      draft: buildDraft(this.filters),
    };
  },
  computed: {
    isDirty() {
      const applied = buildDraft(this.filters);
      return (
        this.draft.sort !== applied.sort || this.draft.status !== applied.status
      );
    },
  },
  watch: {
    visible(isVisible) {
      if (!isVisible) return;
      this.draft = buildDraft(this.filters);
    },
  },
  methods: {
    handleApply() {
      if (!this.isDirty) return;

      this.$emit("apply", {
        sort: this.draft.sort,
        status: this.draft.status,
      });
    },
    handleClear() {
      this.draft = buildDraft({});
      this.$emit("clear");
    },
  },
};
</script>

<style scoped lang="less">
@import "~@/shared/styles/variables.less";

.freight-table-tab-filter-modal__section {
  padding: 16px 0;

  &:first-child {
    padding-top: 0;
  }

  & + & {
    border-top: 1px solid @color-bg-subtle;
  }
}

.freight-table-tab-filter-modal__label {
  font-size: 14px;
  font-weight: 600;
  color: @color-text-dark;
  margin: 0 0 12px 0;
}

.freight-table-tab-filter-modal__stacked {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
</style>

<style lang="less">
@import "~@/shared/styles/variables.less";

.freight-table-tab-filter-modal {
  .ant-modal-title {
    font-size: 16px;
    font-weight: 600;
    color: @color-text-dark;
  }

  .ant-modal-body {
    padding: 24px;
  }

  .ant-radio-checked .ant-radio-inner {
    border-color: @color-primary;

    &::after {
      background-color: @color-primary;
    }
  }

  .ant-btn-primary:not([disabled]) {
    background-color: @color-primary;
    border-color: @color-primary;

    &:hover,
    &:focus {
      background-color: @color-primary-hover;
      border-color: @color-primary-hover;
    }
  }
}
</style>
